module.exports = __webpack_public_path__ + "img/toy_img@2x.af464ecf.png";